import { Grid } from "@mui/material";
import { TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  CmpButton,
  CmpDatePickerField,
  CmpInputField,
  CmpSelectField,
  CmpTypographyField,
} from "../../../Component/Common/ToolBox/ToolBox";

import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import {
  Set_HeadObject_Init,
  Set_WmsDashboard_HeadObject_Set,
} from "../SliceWmsDashboard";
import { TimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import {
  ErrorMsg,
  fKeyLoadingReceipt,
  fSave,
  G1_LoadVersion,
  G1_PendingPO_Attributes,
  G1_POPending_DELETE,
  G1_POPending_POST_REVERSE,
} from "../WmsDashboardAction";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { WmsDashboardRo } from "../../../Redux/roStore";
import {
  CmpDatePickerField001V1,
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../../Component/Common/ToolBox/ToolBoxV1";
export default function PurchaseOrder() {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const vRdxWmsHead = useSelector(
    (state) => state.SliceWmsDashboard.value.HeadObject
  );
  const [xErrorMsg, setErrorMsg] = useState(ErrorMsg);
  const [sAttribute, setAttribute] = useState({
    UnBayLoading: [],
    Receiver: [],
    Version: [],
    Type: [],
    Party: [],
  });

  const calculateTimeDifference = (start, end) => {
    if (!start || !end) return "";
    const startDate = dayjs(start);
    const endDate = dayjs(end);
    const diff = endDate.diff(startDate, "minute");
    return diff >= 0 ? diff : ""; // Ensure positive values
  };
  const handleTimeDifference = (startTime, finishTime) => {
    if (startTime && finishTime) {
      // Convert "HH:mm:ss" strings back to dayjs objects
      const start = dayjs(startTime, "HH:mm:ss");
      const finish = dayjs(finishTime, "HH:mm:ss");

      const diffInMinutes = finish.diff(start, "minute"); // Calculate the difference in minutes
     return diffInMinutes
    } else {
      return 0 // Reset if one of the values is missing
    }
  };
  useEffect(() => {
    const { HeadObject } = WmsDashboardRo();
    const { Title } = WmsDashboardRo();
    G1_PendingPO_Attributes(
      setAttribute,
      HeadObject?.VoucherNo,
      HeadObject?.VoucherTypeCode,
      Title?.trntype
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <Grid container spacing={0.9}>
        <Grid item xs={9} md={4}>
          <CmpSelectFieldV1
            xtabIndex={"1"}
            xLabelText="Type"
            xValue={vRdxWmsHead.Type}
            xOnChange={(e) => {
              dispatch(
                Set_WmsDashboard_HeadObject_Set({
                  ...vRdxWmsHead,
                  Type: e.target.value,
                })
              );
            }}
            xName={"Type"}
            xData={sAttribute?.Type}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsg.Type === "" ? false : true}
            xErrorMessage={xErrorMsg.Type}
            xDisable={false}
            // xOnKeyUp={xKey}
          />
        </Grid>

        <Grid item xs={3} md={4}>
          <CmpTextFieldV1
            xLabelText="Voucher Type"
            xValue={vRdxWmsHead.VoucherTypeCode}
            xType={"text"} // text/number/password
            xName={"VoucherTypeCode"}
            xReadOnly={false}
            xOnChange={(e) => {
              dispatch(
                Set_WmsDashboard_HeadObject_Set({
                  ...vRdxWmsHead,
                  VoucherTypeCode: e.target.value,
                })
              );
              G1_LoadVersion();
            }}
            xError={xErrorMsg.VoucherTypeCode === "" ? false : true}
            xErrorMessage={xErrorMsg.VoucherTypeCode}
            // xOnKeyUp={fKeyLoadingReceipt}
          />
        </Grid>
        <Grid item xs={6} md={4}>
          <CmpTextFieldV1
            xLabelText="VocTypName"
            xValue={vRdxWmsHead.VoucherTypeName}
            xType={"text"} // text/number/password
            xName={"VoucherTypeName"}
            xReadOnly={false}
            xOnChange={(e) => {
              dispatch(
                Set_WmsDashboard_HeadObject_Set({
                  ...vRdxWmsHead,
                  VoucherTypeName: e.target.value,
                })
              );
            }}
            xError={xErrorMsg.VoucherTypeName === "" ? false : true}
            xErrorMessage={xErrorMsg.VoucherTypeName}
            // xOnKeyUp={fKeyLoadingReceipt}
          />
        </Grid>

        <Grid item xs={9} md={4}>
          <CmpTextFieldV1
            xLabelText="Voucher No"
            xValue={vRdxWmsHead.VoucherNo}
            xType={"text"} // text/number/password
            xName={"VoucherNo"}
            xReadOnly={false}
            xOnChange={(e) => {
              dispatch(
                Set_WmsDashboard_HeadObject_Set({
                  ...vRdxWmsHead,
                  VoucherNo: e.target.value,
                })
              );
              G1_LoadVersion();
            }}
            xError={xErrorMsg.VoucherNo === "" ? false : true}
            xErrorMessage={xErrorMsg.VoucherNo}
            // xOnKeyUp={fKeyLoadingReceipt}
          />
        </Grid>

        <Grid item xs={9} md={4}>
          <CmpDatePickerField001V1
            xLabelText="Ref.Date"
            xtabIndex={"4"}
            xValue={vRdxWmsHead.RefDate}
            xOnChange={(e) => {
              if (
                e?.$d == "Invalid Date" ||
                e?.$d == null ||
                e?.$d === undefined ||
                e?.$d === ""
              ) {
                dispatch(
                  Set_WmsDashboard_HeadObject_Set({
                    ...vRdxWmsHead,
                    RefDate: "",
                  })
                );
              } else {
                dispatch(
                  Set_WmsDashboard_HeadObject_Set({
                    ...vRdxWmsHead,
                    RefDate: e?.$d,
                  })
                );
              }
            }}
            xError={xErrorMsg.RefDate === "" ? false : true}
            xErrorMessage={xErrorMsg.RefDate}
            // xOnKeyUp={(e) => {
            //   xFocusInput("A_RefDocNo");
            // }}
          />
        </Grid>

        <Grid item xs={9} md={4}>
          <CmpSelectFieldV1
            xtabIndex={"1"}
            xLabelText="Version"
            xValue={vRdxWmsHead.Version}
            xOnChange={(e) => {
              dispatch(
                Set_WmsDashboard_HeadObject_Set({
                  ...vRdxWmsHead,
                  Version: e.target.value,
                })
              );
            }}
            xName={"Version"}
            xData={sAttribute?.Version}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsg.Version === "" ? false : true}
            xErrorMessage={xErrorMsg.Version}
            xDisable={false}
            // xOnKeyUp={xKey}
          />
        </Grid>

        <Grid item xs={3} md={4}>
          <CmpTextFieldV1
            xLabelText="Party"
            xValue={vRdxWmsHead.PartyCode}
            xType={"text"} // text/number/password
            xName={"PartyCode"}
            xReadOnly={false}
            xOnChange={(e) => {
              dispatch(
                Set_WmsDashboard_HeadObject_Set({
                  ...vRdxWmsHead,
                  PartyCode: e.target.value,
                })
              );
            }}
            xError={xErrorMsg.PartyCode === "" ? false : true}
            xErrorMessage={xErrorMsg.PartyCode}
            // xOnKeyUp={fKeyLoadingReceipt}
          />
        </Grid>
        <Grid item xs={6} md={8}>
          {/* <CmpInputField
            xValue={vRdxWmsHead.PartyName}
            xType={"text"} // text/number/password
            xName={"PartyName"}
            xReadOnly={false}
            xOnChange={(e) => {
              dispatch(
                Set_WmsDashboard_HeadObject_Set({
                  ...vRdxWmsHead,
                  PartyName: e.target.value,
                })
              );
            }}
            xError={xErrorMsg.PartyName === "" ? false : true}
            xErrorMessage={xErrorMsg.PartyName}
            // xOnKeyUp={fKeyLoadingReceipt}
          /> */}
          <CmpSelectFieldV1
            xtabIndex={"1"}
            xLabelText="PartyName"
            xValue={vRdxWmsHead.PartyName}
            xOnChange={(e) => {
              dispatch(
                Set_WmsDashboard_HeadObject_Set({
                  ...vRdxWmsHead,
                  PartyName: e.target.value,
                })
              );
            }}
            xName={"PartyName"}
            xData={sAttribute?.Party}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsg.PartyName === "" ? false : true}
            xErrorMessage={xErrorMsg.PartyName}
            xDisable={false}
            // xOnKeyUp={xKey}
          />
        </Grid>

        <Grid item xs={9} md={4}>
          <CmpDatePickerField001V1
            xLabelText="Exp.Date"
            xtabIndex={"4"}
            xValue={vRdxWmsHead.ExpiryDate}
            xOnChange={(e) => {
              if (
                e?.$d == "Invalid Date" ||
                e?.$d == null ||
                e?.$d === undefined ||
                e?.$d === ""
              ) {
                dispatch(
                  Set_WmsDashboard_HeadObject_Set({
                    ...vRdxWmsHead,
                    ExpiryDate: "",
                  })
                );
              } else {
                dispatch(
                  Set_WmsDashboard_HeadObject_Set({
                    ...vRdxWmsHead,
                    ExpiryDate: e?.$d,
                  })
                );
              }
            }}
            xError={xErrorMsg.ExpiryDate === "" ? false : true}
            xErrorMessage={xErrorMsg.ExpiryDate}
            // xOnKeyUp={(e) => {
            //   xFocusInput("A_RefDocNo");
            // }}
          />
        </Grid>

        <Grid item xs={9} md={4}>
          <CmpTextFieldV1
            xLabelText="PO Net Amount"
            xValue={vRdxWmsHead.PoNetAmount}
            xType={"text"} // text/number/password
            xName={"PoNetAmount"}
            xReadOnly={false}
            xOnChange={(e) => {
              dispatch(
                Set_WmsDashboard_HeadObject_Set({
                  ...vRdxWmsHead,
                  PoNetAmount: e.target.value,
                })
              );
            }}
            xError={xErrorMsg.PoNetAmount === "" ? false : true}
            xErrorMessage={xErrorMsg.PoNetAmount}
            // xOnKeyUp={fKeyLoadingReceipt}
          />
        </Grid>

        <Grid item xs={9} md={4}>
          <CmpTextFieldV1
            xLabelText="No of line items"
            xValue={vRdxWmsHead.NoOfLineItems}
            xType={"text"} // text/number/password
            xName={"NoOfLineItems"}
            xReadOnly={false}
            xOnChange={(e) => {
              dispatch(
                Set_WmsDashboard_HeadObject_Set({
                  ...vRdxWmsHead,
                  NoOfLineItems: e.target.value,
                })
              );
            }}
            xError={xErrorMsg.NoOfLineItems === "" ? false : true}
            xErrorMessage={xErrorMsg.NoOfLineItems}
            // xOnKeyUp={fKeyLoadingReceipt}
          />
        </Grid>

        <Grid item xs={9} md={4}>
          <CmpDatePickerField001V1
            xLabelText="GRN Date"
            xtabIndex={"4"}
            xValue={vRdxWmsHead.GRNDate}
            xOnChange={(e) => {
              if (
                e?.$d == "Invalid Date" ||
                e?.$d == null ||
                e?.$d === undefined ||
                e?.$d === ""
              ) {
                dispatch(
                  Set_WmsDashboard_HeadObject_Set({
                    ...vRdxWmsHead,
                    GRNDate: "",
                  })
                );
              } else {
                dispatch(
                  Set_WmsDashboard_HeadObject_Set({
                    ...vRdxWmsHead,
                    GRNDate: e?.$d,
                  })
                );
              }
            }}
            xError={xErrorMsg.GRNDate === "" ? false : true}
            xErrorMessage={xErrorMsg.GRNDate}
            // xOnKeyUp={(e) => {
            //   xFocusInput("A_RefDocNo");
            // }}
          />
        </Grid>

        <Grid item xs={9} md={4}>
          <CmpTextFieldV1
            xLabelText="InvNo"
            xValue={vRdxWmsHead.InvNo}
            xType={"text"} // text/number/password
            xName={"InvNo"}
            xReadOnly={false}
            xOnChange={(e) => {
              dispatch(
                Set_WmsDashboard_HeadObject_Set({
                  ...vRdxWmsHead,
                  InvNo: e.target.value,
                })
              );
            }}
            xError={xErrorMsg.PoNetAmount === "" ? false : true}
            xErrorMessage={xErrorMsg.PoNetAmount}
            // xOnKeyUp={fKeyLoadingReceipt}
          />
        </Grid>

        <Grid item xs={9} md={4}>
          <CmpDatePickerField001V1
            xLabelText="InvDate"
            xtabIndex={"4"}
            xValue={vRdxWmsHead.InvDate}
            xOnChange={(e) => {
              if (
                e?.$d == "Invalid Date" ||
                e?.$d == null ||
                e?.$d === undefined ||
                e?.$d === ""
              ) {
                dispatch(
                  Set_WmsDashboard_HeadObject_Set({
                    ...vRdxWmsHead,
                    InvDate: "",
                  })
                );
              } else {
                dispatch(
                  Set_WmsDashboard_HeadObject_Set({
                    ...vRdxWmsHead,
                    InvDate: e?.$d,
                  })
                );
              }
            }}
            xError={xErrorMsg.InvDate === "" ? false : true}
            xErrorMessage={xErrorMsg.InvDate}
            // xOnKeyUp={(e) => {
            //   xFocusInput("A_RefDocNo");
            // }}
          />
        </Grid>

        <Grid item xs={3} md={4}>
          <CmpSelectFieldV1
            xtabIndex={"1"}
            xLabelText="AllocateReceiver"
            xValue={vRdxWmsHead.AllocateReceiver}
            xOnChange={(e) => {
              dispatch(
                Set_WmsDashboard_HeadObject_Set({
                  ...vRdxWmsHead,
                  AllocateReceiver: e.target.value,
                })
              );
            }}
            xName={"AllocateReceiver"}
            xData={sAttribute?.Receiver}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsg.AllocateReceiver === "" ? false : true}
            xErrorMessage={xErrorMsg.AllocateReceiver}
            xDisable={false}
            // xOnKeyUp={xKey}
          />
        </Grid>

        <Grid item xs={4} md={4}>
          <CmpSelectFieldV1
            xtabIndex={"1"}
            xLabelText="UnloadingBay"
            xValue={vRdxWmsHead.UnloadingBay}
            xOnChange={(e) => {
              dispatch(
                Set_WmsDashboard_HeadObject_Set({
                  ...vRdxWmsHead,
                  UnloadingBay: e.target.value,
                })
              );
            }}
            xName={"UnloadingBay"}
            xData={sAttribute?.UnBayLoading}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsg.UnloadingBay === "" ? false : true}
            xErrorMessage={xErrorMsg.UnloadingBay}
            xDisable={false}
            // xOnKeyUp={xKey}
          />
        </Grid>

        <Grid item xs={9} md={4}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
              label="ExpStartTime"
              value={
                vRdxWmsHead.ExpStartTime
                  ? dayjs(vRdxWmsHead.ExpStartTime, "HH:mm:ss")
                  : null
              }
              onChange={(newValue) => {
                dispatch(
                  Set_WmsDashboard_HeadObject_Set({
                    ...vRdxWmsHead,
                    ExpStartTime: newValue ? newValue.format("HH:mm:ss") : "",

                    TotalTimeinMin:  handleTimeDifference(newValue ? newValue.format("HH:mm:ss") : "" ,vRdxWmsHead.ExpFinishTime)
                  })
                );
              }}
              ampm={false} // 24-hour format
              views={["hours", "minutes", "seconds"]} // Include seconds
              format="HH:mm:ss" // Display format
              renderInput={(params) => <TextField {...params}   size="small" fullWidth/>}
            />
            {/* <TimePicker
                views={["hours", "minutes", "seconds"]}
                format="HH:mm:ss"
                label="ExpStartTime"
                value={vRdxWmsHead.ExpStartTime}
                onChange={(time) => {
                  console.log(time);

                  dispatch(
                    Set_WmsDashboard_HeadObject_Set({
                      ...vRdxWmsHead,
                      // ExpStartTime: time.$d,
                      ExpStartTime:time?.format("HH:mm:ss"),
                      // ,
                      // TotalTimeinMin: calculateTimeDifference(
                      //   time,
                      //   vRdxWmsHead.ExpFinishTime
                      // ),
                    })
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    fullWidth
                    error={!!xErrorMsg.ExpStartTime}
                    helperText={xErrorMsg.ExpStartTime}
                  />
                )}
              /> */}
          </LocalizationProvider>
        </Grid>

        <Grid item xs={9} md={4}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
          <TimePicker
              label="ExpFinishTime"
              value={
                vRdxWmsHead.ExpStartTime
                  ? dayjs(vRdxWmsHead.ExpFinishTime, "HH:mm:ss")
                  : null
              }
              onChange={(newValue) => {
                dispatch(
                  Set_WmsDashboard_HeadObject_Set({
                    ...vRdxWmsHead,
                    ExpFinishTime: newValue ? newValue.format("HH:mm:ss") : "",
                    TotalTimeinMin:  handleTimeDifference(vRdxWmsHead.ExpFinishTime,newValue ? newValue.format("HH:mm:ss") : "" )
                  })
                );
              }}
              ampm={false} // 24-hour format
              views={["hours", "minutes", "seconds"]} // Include seconds
              format="HH:mm:ss" // Display format
              renderInput={(params) => <TextField {...params}   size="small" fullWidth/>}
            />
            {/* <TimePicker
              label="ExpFinishTime"
              size="small"
              value={
                vRdxWmsHead.ExpFinishTime
                  ? dayjs(vRdxWmsHead.ExpFinishTime)
                  : null
              }
              onChange={(time) => {
                dispatch(
                  Set_WmsDashboard_HeadObject_Set({
                    ...vRdxWmsHead,
                    ExpFinishTime: time.$d,
                    TotalTimeinMin: calculateTimeDifference(
                      vRdxWmsHead.ExpStartTime,
                      time
                    ),
                  })
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  fullWidth
                  error={!!xErrorMsg.ExpFinishTime}
                  helperText={xErrorMsg.ExpFinishTime}
                />
              )}
            /> */}
          </LocalizationProvider>
        </Grid>

        <Grid item xs={9} md={4}>
          <CmpTextFieldV1
            xLabelText="TotalTimeinMin"
            // xValue={vRdxWmsHead.TotalTimeinMin}
            xValue={vRdxWmsHead.TotalTimeinMin}
            
            xType={"text"} // text/number/password
            xName={"TotalTimeinMin"}
            xReadOnly={false}
            xOnChange={(e) => {
              dispatch(
                Set_WmsDashboard_HeadObject_Set({
                  ...vRdxWmsHead,
                  TotalTimeinMin: e.target.value,
                })
              );
            }}
            xError={xErrorMsg.TotalTimeinMin === "" ? false : true}
            xErrorMessage={xErrorMsg.TotalTimeinMin}
            // xOnKeyUp={fKeyLoadingReceipt}
          />
        </Grid>

        <Grid item xs={9} md={4}>
          <CmpTextFieldV1
            xLabelText="GRNNetAmt"
            xValue={vRdxWmsHead.GRNNetAmt}
            xType={"text"} // text/number/password
            xName={"GRNNetAmt"}
            xReadOnly={false}
            xOnChange={(e) => {
              dispatch(
                Set_WmsDashboard_HeadObject_Set({
                  ...vRdxWmsHead,
                  GRNNetAmt: e.target.value,
                })
              );
            }}
            xError={xErrorMsg.GRNNetAmt === "" ? false : true}
            xErrorMessage={xErrorMsg.GRNNetAmt}
            // xOnKeyUp={fKeyLoadingReceipt}
          />
        </Grid>

        <Grid item xs={9} md={4}>
          <CmpTextFieldV1
            xLabelText="NoOfItems"
            xValue={vRdxWmsHead.NoOfItems}
            xType={"text"} // text/number/password
            xName={"NoOfItems"}
            xReadOnly={false}
            xOnChange={(e) => {
              dispatch(
                Set_WmsDashboard_HeadObject_Set({
                  ...vRdxWmsHead,
                  NoOfItems: e.target.value,
                })
              );
            }}
            xError={xErrorMsg.NoOfItems === "" ? false : true}
            xErrorMessage={xErrorMsg.NoOfItems}
            // xOnKeyUp={fKeyLoadingReceipt}
          />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={0}
        className="my-2  "
        sx={{ alignItems: "center", justifyContent: "center" }}
      >
        <Grid item xs={4} md={2} className="text-center">
          <CmpButton
            xbtnName="New"
            xOnClick={(e) => {
              dispatch(Set_HeadObject_Init()); // Head Clearing
            }}
            xVariant="contained"
            xDisabled={false}
            xSize="small"
            xId={"IdNew"}
            xSendIcon={<AddBoxRoundedIcon />}
          />
        </Grid>
        <Grid item xs={4} md={2} className="text-center">
          <CmpButton
            xbtnName="Save"
            xOnClick={(e) => {
              fSave();
            }}
            xVariant="contained"
            xDisabled={false}
            xSize="small"
            xId={"IdSave"}
            xSendIcon={<SaveRoundedIcon />}
          />
        </Grid>

        <Grid item xs={4} md={2} className="text-center">
          <CmpButton
            xbtnName="Delete"
            xOnClick={(e) => {
              G1_POPending_DELETE();
            }}
            xVariant="contained"
            xDisabled={false}
            xSize="small"
            xId="IdDelete"
            xSendIcon={<DeleteRoundedIcon />}
          />
        </Grid>
        <Grid item xs={4} md={2} className="text-center">
          <CmpButton
            xbtnName="Post"
            xOnClick={(e) => {
              G1_POPending_POST_REVERSE("POST");
            }}
            xVariant="contained"
            xDisabled={false}
            xSize="small"
            xId="IdDelete"
            xSendIcon={<DeleteRoundedIcon />}
          />
        </Grid>
        <Grid item xs={4} md={2} className="text-center">
          <CmpButton
            xbtnName="Reverse"
            xOnClick={(e) => {
              G1_POPending_POST_REVERSE("REVERSE");
            }}
            xVariant="contained"
            xDisabled={false}
            xSize="small"
            xId="IdDelete"
            xSendIcon={<DeleteRoundedIcon />}
          />
        </Grid>
        <Grid item xs={4} md={2} className="text-center">
          <CmpButton
            xbtnName="Back"
            xOnClick={(e) => {
              navigate("/wmsDashoard");
            }}
            xVariant="contained"
            xDisabled={false}
            xSize="small"
            xId="IdDelete"
            xSendIcon={<ArrowBackIcon />}
          />
        </Grid>
      </Grid>
    </div>
  );
}
